import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, SubTitle } from "../../Components/CustomComponents";
import Table from "../../Components/Table/Table";
import styles from "./styles/training_management.module.scss";

//
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
import { ShimmerTable } from "react-shimmer-effects";
import CustomSpinner from "../../Components/CustomComponents/CustomSpinner";
import DeleteModal from "../../Components/Modals/DeleteModal";
import TrainingClasses from "../../Components/Modals/TrainingClasses";
import {
  useDeleteClassMutation,
  useGetAllCategoryQuery,
  useGetAllClassesQuery,
} from "../../Data/services/trainingApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { uniqueId } from "lodash";
import LazyLoad from "react-lazy-load";
import ImageWithPlaceholder from "../../Components/CustomComponents/ImageWithPlaceholder";
import ViewEventModal from "../../Components/Modals/ViewPostModal";
import AddUpdateEventModal from "../../Components/Modals/AddUpdateClassModal";
// import { useGetAllPostsQuery } from "../../services/postApi";
// import { updatePosts } from "../../features/postSlice";

const ClassesManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  const [viewData, setViewData] = useState("");
  const [viewModal, setViewModal] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo
  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllClassesQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  // var allPosts = useSelector((state) => state.posts.data);
  // console.log(`allPosts = ${allPosts}`);

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  const handleUpdateModalOpen = () => {
    setUpdateModal(true);
  };

  const handleUpdateModalClose = () => {
    setUpdateModal(false);
    setViewData("");
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setViewData("");
  };

  const [deleteClass, { isLoading: isDeleting }] = useDeleteClassMutation();

  const deleteData = async (id) => {
    // console.log(editedData.slug);
    // console.log(id);

    const postSlug = id;

    try {
      const { data } = await deleteClass(postSlug);

      // console.log(data);

      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    return dataFetched && rowData?.length > 0 ? (
      <ShimmerTable row={5} col={1} />
    ) : (
      <p>NO DATA FOUND</p>
    );
  }
  const columns = [
    {
      dataField: "image_url",
      text: "Traning Image",
      // sort: true,
      headerStyle: {
        width: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <div key={uniqueId()}>
            {
              <LazyLoad
                key={uniqueId()}
                height={100}
                width={100}
                threshold={0.95}
                debounce={500}
                onContentVisible={() => {
                  // console.log("loaded!");
                }}
              >
                <ImageWithPlaceholder
                  src={row.image_url || "/images/user-placeholder.jpeg"}
                  placeholder={"images/placeholder.webp"}
                  alt="training"
                  className="rounded-3"
                  height={100}
                  width={100}
                />
              </LazyLoad>
            }
          </div>
        );
      },
    },
    {
      dataField: "title",
      text: "Name",
      headerStyle: {
        width: "120px",
      },
      formatter: (cellContent, row) => {
        return <td>{`${row?.title || ""}`}</td>;
      },
    },
    {
      dataField: "description",
      text: "Description",
      // sort: true,
      // headerAlign: "center",
      // align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        return `${row?.description || "-"}`;
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      headerStyle: { width: "35%" },
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            {/* View Button */}
            <div
              className={`${styles.btnBg} text-white rounded-3 px-3 py-2 d-flex align-items-center justify-content-center`}
              role="button"
              onClick={() => {
                setViewData(row);
                setViewModal(true);
              }}
            >
              <span className="fw-bold">Class Detail</span>
            </div>
    
            {/* Edit Button */}
            <div
              className="tag_button text-white rounded-3 px-3 py-2 d-flex align-items-center justify-content-center"
              role="button"
              onClick={() => {
                setViewData(row);
                handleUpdateModalOpen(true);
              }}
            >
              <span>Edit</span>
            </div>
    
            {/* Delete Button */}
            <div
              className="delete_button text-white rounded-3 px-3 py-2 d-flex align-items-center justify-content-center"
              role="button"
              onClick={() => {
                setViewData(row);
                handleDeleteModalOpen(true);
              }}
            >
              <span>Delete</span>
            </div>
          </div>
        );
      },
    }
    
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <DeleteModal
          handleDeleteModalClose={handleDeleteModalClose}
          data={viewData}
          onDelete={deleteData}
          isDeleting={isDeleting}
        />
      ) : (
        ""
      )}
      {UpdateModal ? (
        <AddUpdateEventModal
          handleClose={handleUpdateModalClose}
          data={viewData}
          refetch={refetch}
        />
      ) : (
        ""
      )}

      {viewModal ? (
        <ViewEventModal
          handleViewModalClose={() => {
            setViewData(null);
            setViewModal(false);
          }}
          data={viewData}
        />
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <Row className="w-100 flex-start justify-content-between">
          <Col md={6}>
            <div>
              <SubTitle text={"Training Classes"} classes="primary-text" />
            </div>
          </Col>
          {/* <Col md={5}>
            <Input
              placeholder="search by name"
              value={searchQuery}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
          </Col> */}
          <Col md={2}>
            <Button
              classes={`h-100 mt-3 mt-md-0`}
              text="Add Class"
              onClick={handleUpdateModalOpen}
            ></Button>
          </Col>
        </Row>
      </div>

      <div className={styles.mainTable}>
        {!dataFetched ? (
          <CustomSpinner />
        ) : (
          <Table
            classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
            data={rowData ?? []}
            columns={columns}
            indication={indication}
            totalRecords={totalRecords} // todo
            totalPages={totalPages} // todo
            pageSize={pageSize} // todo
            currentPage={currentPage} // todo
            setCurrentPage={setCurrentPage} // todo
            setPageSize={setPageSize} // todo
            refetch={refetch} // todo
          />
        )}
      </div>
    </div>
  );
};

export default ClassesManagementScreen;
